import { render } from "./PaymentTermsForms.vue?vue&type=template&id=8af05e2a"
import script from "./PaymentTermsForms.vue?vue&type=script&lang=js"
export * from "./PaymentTermsForms.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dharmik/www/pfizer-invoicing-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__